import {
  Attributefullobject,
  BaseBooleanAttribute,
  BaseNumericAttribute,
  BaseSelectAttribute,
  Valuesimagesitem,
} from './attributes';
import { Category } from './categories';
import { ImageType } from './files';
import { Promotion } from './promotions';

export enum ListingRequestStatus {
  pending = 1,
  rejected = 2,
  accepted = 3,
}
export interface SolrTemplateResponse {
  id: string;
  name_en: string;
  name_ar: string;
  is_used: boolean;
  image_public_url: string;
  category_id: number;
  category_stack_en: string[];
  category_stack_names_en: string[];
  category_stack_ar: string[];
  category_stack_names_ar: string[];
  category_stack_ids: number[];
  category_keywords: string;
  template_description_en: string;
  template_description_ar: string;
  template_whats_included: string;
  template_watchers: string;
  image_alts: string;
  num_of_attributes: number;
  num_of_variations: number;
  num_of_images_in_template: number;
  is_silal_owned: boolean;
  attribute_text_en: string;
  attribute_text_ar: string;
  _version_: number;
  created_at_dt: string;
  created_by_user_id_i: number;
}

export interface SolrBuyerItemsResponse {
  id: string;
  name_en: string;
  name_ar: string;
  store_name_en: string;
  store_name_ar: string;
  store_id: number;
  in_stock: boolean;
  price: number;
  is_used: boolean;
  image_public_url: string;
  listing_id: number;
  category_id: number;
  category_stack_en: string[];
  category_stack_names_en: string[];
  category_stack_ar: string[];
  category_stack_names_ar: string[];

  category_stack_ids: number[];
  category_keywords: string;
  listing_description_en: string;
  listing_description_ar: string;
  listing_whats_included: string;
  listing_watchers: string;
  variable_attribute_txt_en: string;
  variable_attribute_txt_ar: string;
  avg_rating: number;
  number_of_ratings: number;
  item_orders: number;
  listing_orders: number;
  listing_visits: number;
  num_of_attributes: number;
  num_of_variations: number;
  num_of_images_in_listing: number;
  boost: number;
  is_sponsered: boolean;
  is_silal_owned: boolean;
  created_by_user_id_i: number;
  created_at_dt: string;

  attribute_text_en: string;
  attribute_text_ar: string;
  _version_: number;
  score: number;
}

export interface AttributeAssociation {
  item_id?: number;
  attr_id: number;
  attr_value_image?: ImageType;
  attr_name_en: string;
  attr_name_ar: string;
  is_attribute_custom: boolean;
  attr_value_en: boolean | string;
  attr_value_ar: boolean | string;
  is_variant: boolean;
  attribute_type: number;
  attribute_type_name: string;
  official_values_en: string[];
  official_values_ar: string[];
  unit?: string;
  attribute_full_object: Attributefullobject;
  values_images_items: Valuesimagesitem[];
}

export interface TableCombination {
  valid: boolean;
  attrs: AttributeAssociation[];
  in_stock: boolean;
  original_price: string;
  price: number;
  image_id: number;
  barcode: string;
}

export interface ListingVersion {
  id: number;
  date_created: string;
  listing_status_num: number;
  listing_status_name: string;
}

export interface ListingItem {
  item_id: number;
  price: string;
  original_price: string;
  id: number;
  barcode: string;
  in_stock: boolean;
  indexed: boolean;
  attributes: AttributeAssociation[];
  image: ImageType;
  listing_id: number;
  name_en: string;
  name_ar: string;
  is_used: boolean;
  is_silal_owned: boolean;
  listing?: Listing;
  listing_status_num: number;
  listing_status_name: string;
  applied_promotion: Promotion | null;
}

export interface Listing {
  id: number;
  listing_type_name: string;
  listing_type_value: number;
  name_ar: string;
  name_en: string;
  rich_text_description_en: string;
  rich_text_description_ar: string;
  is_used: boolean;
  whats_included: string;
  is_approved: boolean;
  categegory_hidden: boolean;
  freezed_by_management: boolean;
  freezed_by_seller: boolean;
  listing_status_num: number;
  listing_status_name: string;
  category_id: number;
  attributes: AttributeAssociation[];
  items: ListingItem[];
  images: ImageType[];
  watchers?: number;
  cover_image_id: number;
  is_silal_owned: boolean;
  store_id: number;
  width: string;
  height: string;
  length: string;
  weight: string;
  flammable: boolean;
  fragile: boolean;
  keep_dry: boolean;
  created_by_user_id?: number;
  time_to_ship: string;
  date_created: string;
  last_purchase_date?: string;
  current_orders?: number;
  parent_listing_version_id?: number;
  new_listing_version_id?: number;
  official_attributes: Record<number, AttributeAssociation>;
  custom_attributes: Record<number, AttributeAssociation>;
  previouse_versions?: ListingVersion[];
  next_versions?: ListingVersion[];
  description: string;
  barcode: string;
  combinations_table: TableCombination[];
  list_on_approval: boolean;
  parent_listing_id?: number;
  id_of_draft_to_delete?: number;
  listing_type: string;
  request?: ListingRequest;
}

export interface ListingBrief {
  id: number;
  listing_type_name: string;
  listing_type_value: number;
  name_en: string;
  name_ar: string;
  listing_status_num: number;
  listing_status_name: string;
  category_id: number;
  cover_image: ImageType;
  created_by_user_id?: number;
  date_created: string;
  store_id: number;
  is_silal_owned: boolean;
}

interface ListingRequest {
  id: number;
  request_date: string;
  archived: boolean;
  status: number;
  status_name: string;
  request_type: number;
  request_type_name: string;
  response: ListingResponse;
  store_id: number;
  store_name: string;
  seller_id: number;
  parent_listing_id: number;
  new_listing_id: number;
  new_listing_name: string;
}

interface ListingResponse {
  id: number;
  request_id: number;
  manager_id: number;
  response_date: string;
  msg: string;
  read: boolean;
}

export type ListingState = {
  productType: number;
  userType: number; // 0 for seller, 1 for management
  data: {
    attributes: AttributeAssociation[];
    price: string;
    original_price?: string;
    in_stock: boolean;
    images: number[];
    imagesList: ImageType[];
    cover_image_id: null | number;
    name_en: string;
    name_ar: string;
    description_en: string;
    description_ar: string;
    whats_included: string;
    barcode: string;
    // time_to_ship: string;
    category_id: number;
    category?: Category;

    weight: string;
    length: string;
    height: string;
    width: string;

    flammable: boolean;
    fragile: boolean;
    keep_dry: boolean;

    official_attributes?: Record<number, AttributeAssociation>;

    select_attrs: BaseSelectAttribute[];
    numeric_attrs: BaseNumericAttribute[];
    boolean_attrs: BaseBooleanAttribute[];
    combinations_table: TableCombination[];
    prev_combinations_table: TableCombination[];
    list_on_approval: boolean;
    is_used: boolean;
    parent_listing_id: null | number;
    id_of_draft_to_delete: null | number;
    listing_type: string;
    selectedImages: Record<string, any>;
    notToUploadImages: number[];
    request?: ListingRequest;
    applied_promotion?: Promotion;
  };
  all_attributes: Attributefullobject[];
  error_fields: {
    price: string;
    in_stock: boolean;
    images: string[];
    imagesList: string[];
    cover_image_id: number;
    name_en: string;
    name_ar: string;
    description: string;
    whats_included: string;
    barcode: string;
    time_to_ship: string;
    category_id: number;

    weight: string;
    length: string;
    height: string;
    width: string;

    flammable: boolean;
    fragile: boolean;
    keep_dry: boolean;
    selectedImages: Record<string, any>;
    select_attrs: any[];
    numeric_attrs: any[];
    boolean_attrs: any[];
    combinations_table: any[];
    list_on_approval: boolean;
    is_used: boolean;
    parent_listing_id: null | number;
    id_of_draft_to_delete: null | number;
    listing_type: 'public_listing';
  };
};

export type TemplateBrief = {
  id: number;
  listing_type_name: string;
  listing_type_value: number;
  name_en: string;
  name_ar: string;
  listing_status_num: number;
  listing_status_name: string;
  category_id: number;
  cover_image: ImageType;
  created_by_user_id?: number;
  date_created: string;
  store_id: number;
  is_silal_owned: boolean;
};
